import React, { createContext, useContext, useReducer } from 'react';

import { IGeneral } from '@/shared/types';

import { homePageReducer, homePageTypes } from './reducer';

/******************************************************************************************
             NOTE: Add any global data for home page here  
/*************************************************************************************** */

export type InitialStateType = {
  date: Date;
  crop?: IGeneral.ICropSchema;
};

const initialState = {
  date: new Date(),
  crop: undefined,
};

const HomePageContext = createContext<{
  state: InitialStateType;
  setDate: (date: Date) => void;
  setCrop: (crop?: IGeneral.ICropSchema) => void;
}>({
  state: initialState,
  setDate: () => {
    return;
  },
  setCrop: () => {
    return;
  },
});

const HomePageProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [state, dispatch] = useReducer(homePageReducer, initialState);

  // action creators
  const setDate = (date: Date) => {
    dispatch({ type: homePageTypes.setDate, payload: date });
  };
  const setCrop = (crop?: IGeneral.ICropSchema) => {
    dispatch({ type: homePageTypes.setCrop, payload: crop });
  };

  return (
    <HomePageContext.Provider value={{ state, setDate, setCrop }}>
      {children}
    </HomePageContext.Provider>
  );
};
const useHomePageContext = () => useContext(HomePageContext);

export { HomePageProvider, useHomePageContext };
